export enum QueryKey {
  SHIFT_TASKS = 'SHIFT_TASKS',
}
